import { VirtualInterviewAssociatedList, VirtualInterviewRatingsId } from '../constants';
import { getIfElementOfArrayPresentInAnotherArray } from './helper';

export const useVoiceAdvantageOptionDisabled = virtualRatingsOrderPriorities => {
  if (virtualRatingsOrderPriorities && virtualRatingsOrderPriorities?.length > 0) {
    return getIfElementOfArrayPresentInAnotherArray(
      virtualRatingsOrderPriorities,
      'value',
      VirtualInterviewAssociatedList,
    );
  }
  return false;
};

export const useAtoIValuesAlreadyPresent = selectedOrderPriorities => {
  if (selectedOrderPriorities && selectedOrderPriorities.length > 0) {
    return selectedOrderPriorities.some(x => {
      const value = parseInt(x?.value, 10);
      return value >= parseInt(VirtualInterviewRatingsId.A) && value <= parseInt(VirtualInterviewRatingsId.I);
    });
  }
  return false;
};
